module.exports = __webpack_public_path__ + "static/img/jlb.8a754ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jlb.jpg
// module id = odQg
// module chunks = 1